<template>
    <div>
        <div>
            <form name="reqKcbForm"  action="#" method="post" >
                <input type="hidden" name="cpCd" v-model="cpCd">
                <input type="hidden" name="mdlTkn"  v-model="mdlTkn">
            </form>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
export default {
    name: 'CallKcpAuthPop',
    data() {
        return {
            cpCd:'',
            mdlTkn:''
        }
    },
    created() {
            this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 카드인증 정보
         **/
        getInfo() {
            var url = location.href;
            url = url.split('//');
            url = url[1].substr(0,url[1].indexOf('/'));
            let tourl = "https://card.ok-name.co.kr/popup/main/start.do";           // 운영 URL

            if(url.indexOf("stg") != -1) {
                tourl ="https://"+ url+"/ococ/datacapture/auth/resultKcbPop";//test URL
            }else if( url.indexOf("local") != -1){
                tourl = "http://localhost:8081/ococ/datacapture/auth/resultKcbPop";//test URL
            }

              this.cpCd = "V46100000000"//res.data.cpCd
                // 서버의 API를 호출하는 URL
              this.mdlTkn = this.$route.query.mdlTkn
         //  alert(tourl);
                this.$nextTick(()=>{
                    document.reqKcbForm.action = tourl
                    document.reqKcbForm.submit()
                })
        },
    },
}
</script>

<style scoped>

</style>